import React from "react";

import { Button, Modal, useManualModalState } from "@synthesis/shared-ui";

import { useStores } from "../../../store";
import { AddFile } from "../../toolbar/local-components";

type ModalIntegrationProjectType = {
  disabledRight?: boolean;
  isOpen?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  openModal?: () => void;
  closeModal?: () => void;
  isModalIntegration?: { addFile?: boolean; rename: boolean; isOpen: boolean; updateVersion: boolean; delete: boolean };
  setIsModalIntegration?: (isModalIntegration: {
    addFile: boolean;
    rename: boolean;
    isOpen: boolean;
    updateVersion: boolean;
    delete: boolean;
  }) => void;
  setIsOpenRename?: (isRename: boolean) => void;
  setIsOpenDeleteFile?: (isDelete: boolean) => void;
  uploadFileRequest?: () => void;
};

const ModalIntegrationProject = React.memo((props: ModalIntegrationProjectType) => {
  const { disabledRight, isModalIntegration, setIsOpenRename, setIsModalIntegration, setIsOpenDeleteFile, uploadFileRequest } = props;
  return (
    <Modal.Root manual {...props}>
      <ModalIntegrationProjectContext
        disabledRight={disabledRight}
        isModalIntegration={isModalIntegration}
        setIsOpenRename={setIsOpenRename}
        setIsModalIntegration={setIsModalIntegration}
        setIsOpenDeleteFile={setIsOpenDeleteFile}
        uploadFileRequest={uploadFileRequest}
      />
    </Modal.Root>
  );
});

const defaultIntegrationState = {
  addFile: false,
  rename: false,
  isOpen: false,
  updateVersion: false,
  delete: false,
} as const;

const ModalIntegrationProjectContext = React.memo(
  ({
    disabledRight,
    isModalIntegration,
    setIsOpenRename,
    setIsModalIntegration,
    setIsOpenDeleteFile,
    uploadFileRequest,
  }: ModalIntegrationProjectType) => {
    const { generalStore } = useStores();
    const { closeModal } = useManualModalState();
    const integration = isModalIntegration ?? defaultIntegrationState;

    const handleUpdate = async () => {
      handleClose();
      if (integration.rename) {
        setIsOpenRename?.(true);
      }
      if (integration.delete) {
        setIsOpenDeleteFile?.(true);
      }
      if (integration.updateVersion) {
        uploadFileRequest?.();
      }
    };
    const handleClose = () => {
      setIsModalIntegration?.({ ...defaultIntegrationState });
      closeModal();
    };

    const renderTitle = () => {
      if (integration.addFile) {
        return "Добавить файл";
      }
      if (integration.rename) {
        return `Переименовать файл`;
      }
      if (integration.delete) {
        return `Удалить файл${generalStore.checkedFiles.size > 1 ? "ы" : ""}`;
      }
      if (integration.updateVersion) {
        return "Загрузить версию";
      }
      return "";
    };

    return (
      <Modal.Content className="min-w-[550px]">
        <Modal.Title>Редактирование общей информации</Modal.Title>
        <div className="p-6">
          <>
            <h2 className="heading-h4">{renderTitle()}?</h2>
            <div className="paragraph-lg py-4">Данные о проекте получены по интеграции. Продолжить?</div>
            <div className="flex justify-between">
              {integration.addFile ? (
                <AddFile isModal={true} closeModal={handleClose} />
              ) : (
                <Button disabled={disabledRight} onClick={handleUpdate} theme="primary">
                  Продолжить
                </Button>
              )}
              <Button size="sm" theme="secondary" onClick={handleClose}>
                Отменить
              </Button>
            </div>
          </>
        </div>
      </Modal.Content>
    );
  },
);
export default ModalIntegrationProject;
